import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleCashFlowStatement = () => {
  const { cashFlowStatementId } = useParams();
  const decodedId = cashFlowStatementId ? atob(cashFlowStatementId) : cashFlowStatementId;
  const id = decodedId.replace(/\D/g, '');  // Ensure we only get the numeric part
  const [cashFlowStatementDetails, setCashFlowStatementDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    const fetchCashFlowStatementDetails = async () => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.cashFlowStatement}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);

        // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at', 'updated_at'];
        const columnsArray = extractedColumns
          .filter((column) => !excludedColumns.includes(column))
          .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          }));

        setColumnDetails(columnsArray);
        setCashFlowStatementDetails(response.data);
      } catch (error) {
        console.error('Error fetching cash flow statement details:', error);
      }
    };

    fetchCashFlowStatementDetails();
  }, [cashFlowStatementId]);

  return (
    <div>
      {cashFlowStatementDetails ? (
        <SingleItemDetailTemplate details={cashFlowStatementDetails} columns={columns} />
      ) : (
        <p>Loading cash flow statement details...</p>
      )}
    </div>
  );
};

export default SingleCashFlowStatement;